import Cookies, { CookieSetOptions } from "universal-cookie";
import { getCookieDomain } from "@pepdirect/v3/helpers/cookieDomain";
import { cookies } from "config";

const expiryInSeconds = 7 * 24 * 60 * 60;
const cookie = new Cookies();

function getCookieOptions(): CookieSetOptions {
  const domain = getCookieDomain();

  return {
    path: "/",
    ...(domain ? { domain } : {}),
    secure: cookies.secureCookie,
    maxAge: expiryInSeconds,
  };
}

export const getZipCodeFromCookie = (): string | undefined => {
  return cookie.get(cookies.zipCode) || undefined;
};

export const setZipCodeCookie = (zip: string): void => {
  cookie.remove(cookies.zipCode);
  cookie.set(cookies.zipCode, zip, getCookieOptions());
};
